import type { NavigationItem } from "../../types/app";

export const navigationItems: readonly NavigationItem[] = [
  { href: "#/", labelAr: "الرئيسية", labelEn: "Home", icon: "home" },
  { href: "#/athkar", labelAr: "الأذكار", labelEn: "Athkar", icon: "athkar" },
  { href: "#/favorites", labelAr: "المفضلة", labelEn: "Favourite", icon: "heart" },
  { href: "#/quran", labelAr: "القرآن", labelEn: "Quran", icon: "book" },
  { href: "#/prayer", labelAr: "الصلاة", labelEn: "Prayer", icon: "prayer" },
  { href: "#/qibla", labelAr: "القبلة", labelEn: "Qibla", icon: "compass" },
  { href: "#/moon", labelAr: "القمر", labelEn: "Moon", icon: "moon" },
  { href: "#/manasik", labelAr: "المناسك", labelEn: "Manasik", icon: "kaaba" },
  { href: "#/duas", labelAr: "الأدعية", labelEn: "Duas", icon: "hands" },
  { href: "#/tasbih", labelAr: "التسبيح", labelEn: "Tasbih", icon: "tasbih" },
  { href: "#/alkhalili", labelAr: "الشيخ الخليلي", labelEn: "Al-Khalili", icon: "book" },
  { href: "#/donate", labelAr: "الصدقة والزكاة", labelEn: "Donate", icon: "heart" },
  { href: "#/about", labelAr: "عن التطبيق", labelEn: "About", icon: "sparkles" }
];

export const primaryNavigationHrefs = ["#/", "#/athkar", "#/quran", "#/prayer"] as const;
export const featuredNavigationHrefs = ["#/favorites", "#/qibla", "#/moon", "#/alkhalili"] as const;
export const supportingNavigationHrefs = ["#/manasik", "#/duas", "#/tasbih", "#/donate", "#/about"] as const;

function normalizeHref(href: string): string {
  return href.replace("#", "") || "/";
}

export function isRouteActive(route: string, href: string): boolean {
  const normalizedRoute = route || "/";
  const normalizedHref = normalizeHref(href);
  return normalizedHref === "/" ? normalizedRoute === "/" : normalizedRoute === normalizedHref;
}

export function getNavigationItemByRoute(route: string): NavigationItem | undefined {
  return navigationItems.find((item) => isRouteActive(route, item.href));
}
